module.exports = __webpack_public_path__ + "img/mmi-about-photo-02-mighty-minds-computer-room-donation.12f6ff0f.png";